import { useEffect, useState } from "react";
import { useThemeContext } from "../../../Context/ThemeContext";
import { Col, Label, Table } from "reactstrap";
import AbsenStafFilterComponent from "./filter/AbsenStafFilterComponent";
import {
  dayNames,
  formatDate,
  getDateToday,
} from "../../../Utils/externalFunctions";
import { getLokasi } from "../utils/getLokasi";

const AbsenStafBulananList = ({
  data,
  monthFilter,
  periode,
  stafId,
  updateMonthFilter,
  resetState,
  pending,
}) => {
  const { themeContext } = useThemeContext();

  const [currentStaf, setCurrentStaf] = useState();
  const [currentGroupStaf, setCurrentGroupStaf] = useState();
  const [dateList, setDateList] = useState([]);

  useEffect(() => {
    setCurrentStaf(data.staf?.find((staf) => staf.id === Number(stafId)));
    setCurrentGroupStaf(
      data.groupStaff?.find(
        (groupStaff) => groupStaff.id_group === Number(currentStaf?.group_staf)
      )
    );
  }, [data.staf, stafId, currentStaf]);

  useEffect(() => {
    if (currentStaf) {
      let monthList = [];
      for (
        let date = new Date(monthFilter + "-01");
        date.getMonth() !== (new Date(monthFilter + "-01").getMonth() + 1) % 12;
        date.setDate(date.getDate() + 1)
      ) {
        const absen = findAbsen(date, data?.absen);
        const event = findEvent(date, data?.event);
        const detailAbsen = findDetailAbsen(absen, data?.detailAbsen);

        monthList.push({
          tanggal: new Date(date),
          absen: absen,
          datang: findAbsenDatang(detailAbsen),
          pulang: findAbsenPulang(detailAbsen),
          event: event || ""
        });
      }
      setDateList(monthList);
    }
  }, [monthFilter, currentStaf, data.absen, data.detailAbsen]);

  const findAbsen = (date, absenList) =>
    absenList?.find(
      (item) => formatDate(date) === formatDate(new Date(item.tanggal))
    );
  const findEvent = (date, eventList) =>
    eventList?.find(
      (item) => formatDate(date) === formatDate(new Date(item.date))
    );
  const findDetailAbsen = (absen, detailAbsenList) =>
    detailAbsenList?.filter((item) => absen?.id_absensi === item.id_absensi);
  const findAbsenDatang = (detailAbsenList) =>
    detailAbsenList?.find((item) => item.mode === 1);
  const findAbsenPulang = (detailAbsenList) =>
    detailAbsenList?.find((item) => item.mode === 2);

  const getRemainingTime = (timestamp) => {
    const isNegative = timestamp < 0;
    const seconds = Math.floor(Math.abs(timestamp) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    return `${isNegative ? "-" : ""}${hours.toString().padStart(2, "0")}:${(
      minutes % 60
    )
      .toString()
      .padStart(2, "0")}:${(seconds % 60).toString().padStart(2, "0")}`;
  };

  return (
    <>
      <Col className={"px-4 pt-2"}>
        <div className={"w-100 row row-cols-6 align-items-center pb-2"}>
          <Label className={"m-0 col"}>Name</Label>
          <div className={"m-0 col-3"}>{currentStaf?.nama}</div>
        </div>
        <AbsenStafFilterComponent
          updateMonthFilter={updateMonthFilter}
          periode={periode}
        />
      </Col>

      <Table>
        <thead>
          <tr>
            <th>Hari</th>
            <th>Tanggal</th>
            <th>Datang</th>
            <th>Pulang</th>
            <th>Lokasi</th>
            <th>Selisih dengan {currentGroupStaf?.jam_masuk || "08:00:00"}</th>
            <th>Selisih dengan {currentGroupStaf?.jam_keluar || "17:00:00"}</th>
            <th className="w-25">Keterangan</th>
          </tr>
        </thead>
        <tbody>
          {dateList.map((date) => {
            const datangTimeStaf = new Date(
              `${getDateToday("original")}T${date.datang?.jam}Z`
            );
            const pulangTimeStaf = new Date(
              `${getDateToday("original")}T${date.pulang?.jam}Z`
            );
            const datangTime = new Date(
              `${getDateToday("original")}T${
                currentGroupStaf?.jam_masuk || "08:00:00"
              }Z`
            );
            const pulangTime = new Date(
              `${getDateToday("original")}T${
                currentGroupStaf?.jam_keluar || "17:00:00"
              }Z`
            );

            const datangSelisih = datangTime - datangTimeStaf;
            const pulangSelisih = pulangTimeStaf - pulangTime;

            return (
              <tr>
                <td>{dayNames[date.tanggal.getDay()]}</td>
                <td>{formatDate(date.tanggal)}</td>
                <td>{date.datang?.jam}</td>
                <td>{date.pulang?.jam}</td>
                <td>{getLokasi(date.datang, date.pulang)}</td>
                <td>
                  {date.datang?.jam ? getRemainingTime(datangSelisih) : ""}
                </td>
                <td>
                  {date.pulang?.jam ? getRemainingTime(pulangSelisih) : ""}
                </td>
                <td className="text-break">{date.absen?.keterangan || date.event?.event}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default AbsenStafBulananList;
